module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAABBAQAAAADHuBTvAAAAAnRSTlMAAHaTzTgAAAAWSURBVHgBYxhuYBSMglEwCkbBKBgFAAffAAHn7MpbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./public/javascripts/shims/styles/transparent.png
// module id = 1318
// module chunks = 0